/**
 * Pure mapping from auth state to the route a user belongs on.
 * @param {object|null} session - supabase session (truthy when logged in)
 * @param {object|null} profile - { role, status } from public.profiles
 * @returns {string} route path
 */
export function resolveHome(session, profile) {
  if (!session) return '/login';
  if (!profile) return '/pending';
  if (profile.status !== 'approved') return '/pending';
  if (['admin', 'super_admin', 'catalogue_admin'].includes(profile.role)) return '/admin';
  if (profile.role === 'design_approver') return '/design-approval';
  if (profile.role === 'supervisor') return '/supervisor';
  return '/operator';
}
